import React from "react"
import { useIntl } from 'react-intl'
import { FormSubGroup, Label } from '../../layout'
import { FilterSelect } from '../components/FilterSelect'
import { SelectContainer, useTowingJobFilterContext } from '../context'
import { customMultiValueStyles } from '../components/MultiValueSelect'
import { towingJobFilterMessages } from '../messages'
import { formatMessageSafe } from '../../../util/translateInputOptions'

interface PriorityOption {
  label: string
  value: number
}
interface PriorityOptionsProps {
  options?: PriorityOption[]
}
export const PriorityFilter = ({ options }: PriorityOptionsProps) => {
  const { values, setValues } = useTowingJobFilterContext()
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const optionsValues = options
    ? options
    : [
        { label: formatMessage(towingJobFilterMessages.priorityNone), value: 0 },
        { label: formatMessage(towingJobFilterMessages.priorityRed), value: 1 },
        { label: formatMessage(towingJobFilterMessages.priorityYellow), value: 2 },
        { label: formatMessage(towingJobFilterMessages.priorityGreen), value: 3 },
      ]

  const handleLabelChange = (selectedOptions: any) => {
    const selectedPriorityTags = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : []

    setValues({
      ...values,
      filters: {
        ...values.filters,
        priorityTag: selectedPriorityTags,
      },
    })
  }

  return (
    <FormSubGroup>
      <Label htmlFor="filter-multiselect">{formatMessage(towingJobFilterMessages.priorityLabel)}</Label>
      <SelectContainer>
        <FilterSelect
          isMulti
          menuPlacement="auto"
          isSearchable={false}
          placeholder={formatMessage(towingJobFilterMessages.selectPlaceholder)}
          options={optionsValues.map(option => ({ value: option.value, label: option.label }))}
          value={optionsValues
            .filter(option => values.filters.priorityTag.includes(option.value))
            .map(option => ({ value: option.value, label: option.label }))}
          onChange={handleLabelChange}
          styles={customMultiValueStyles}
        />
      </SelectContainer>
    </FormSubGroup>
  )
}